import React, { Component } from "react";
import styled from "styled-components";

const UpArrow = require("../../../../assets/imgs/upArrow.png");
const DownArrow = require("../../../../assets/imgs/downArrow.png");

const MainWrapper = styled.div`
  position:relative;
  width:285px;


  
  }
`;
const TooltipText=styled.span`
  visibility: hidden;
  width: 160px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
  &:after{
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
`;
const Tooltip = styled.div`
  position: relative;
  cursor: pointer;
  display: inline-block;
  padding: 0px 4px;
  font-weight: bold;
  margin: 4px 5px;
  border-radius: 100%;
  border: 1px solid gray;
  color: gray;
  width:15px;
  height:15px;
  &:hover ${TooltipText}{
    visibility: visible;
  } 
`;
const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 34px;
  :before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
  }
`;
const MasterInput = styled.input`
  :checked+${Slider} {
    background-color: #1B9F4E;
  }
  :focus+${Slider} {
    box-shadow: 0 0 1px #1B9F4E;
  }
  :checked+${Slider}::before {
    transform: translateX(18px);
  }
`;
const SlaveInput = styled.input`
  :checked+${Slider} {
    background-color: #1B9F4E;
  }
  :focus+${Slider} {
    box-shadow: 0 0 1px #1B9F4E;
  }
  :checked+${Slider}::before {
    transform: translateX(18px);
  }
`;
const Toggle = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;


  ${MasterInput},${SlaveInput} {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
`;
const CardContainer=styled.div`
background: white;
/* box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24); */
// box-shadow: 0 4px 4px rgba(0,0,0,0.12), 0 4px 2px rgba(0,0,0,0.12);
// border-radius: 5px;
border-top-right-radius: 5px;
border-top-left-radius: 5px;
border: none;
padding:10px;
margin-bottom:16px;

`;
const MasterToggle=styled(CardContainer)`
display: flex;
// background-color: #1B9F4E;
//margin: 10px 0px;
// color: white;
justify-content:center;
`;
const CardWrapper=styled.div`
  display:flex;
  justify-content:space-between;
  
  padding: 10px 0px;
  //background: red;
`;
const Title =styled.div`
  display: flex;
`;
const OverlayBlock = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top:0;
  background: rgba(0, 0, 0, 0.2);
  /* z-index: 101; */
`;
const MessageBlock = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 96%;
  transform: translate(-50%, -50%);
  padding: 25px 10px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #ffffff;
`;
const Message = styled.div`
  text-align: center;
  padding-bottom: 12px;
  padding-top: 20px;
`;
const ActionButton = styled.div`
  width: 100%;
  max-width: 200px;
  margin: 10px auto;
  background: #003e8d;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
`;
const CardTitle=styled.div`
font-weight: bold;
padding: 3px 0px;
font-size:13px;
`;
const CloseButton=styled.span`
    position: absolute;
    top: 0px;
    right: 10px;
    padding: 5px;
    color: #003E8D;
    font-size: 30px;
    font-weight: bold;
    transition: 0.3s;
    &:hover,:focus{
    color: red;
    text-decoration: none;
    cursor: pointer;
    }
`
const Button=styled.div`
    background: #003E8D;
    width: 95%;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
    margin: 10px auto;
`;
 

const CardLimitAccordion = styled.div`
position: relative;
margin: 0px 12px;


& .upArrow {
  height: 30px;
  width: 30px;
  position: absolute;
  top: 10px;
  right:1;
 background: url('${UpArrow}');
 // background: red;
  background-repeat: no-repeat;
  cursor:pointer;
}

& .downArrow {

  height: 30px;
  width: 30px;
  position: absolute;
  top: 10px;
  right:1;
  background: url('${DownArrow}');
  //background: red;
  background-repeat: no-repeat;
  cursor:pointer;



`;

const CardLimitSlider = styled.div`
height: auto;
width: 100%;
background: #f4f4f4;
margin:16px 0px;
border-radius:10px;


.cardSliderContainer {
  width: 242px;
  margin:4px 10px;
}
.cardSlider {
  -webkit-appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  -webkit-transition: .2s;
  transition: opacity .2s;
  cursor: pointer;
}
.cardSlider:hover {
  background: #C0C0C0;
}

.cardSlider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #800000;
  border: 8px solid #fff;
  cursor: pointer;
  box-shadow: 0 4px 4px rgba(0,0,0,0.1)
}
.cardSlider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #4CAF50;
  cursor: pointer;
}
`;


class ManageCreditCard extends Component {

  constructor(){
  super()
  this.state={
    masterSwitch:false,
    cardData:[],
    previousToggle:"",
    showButton:false,
    showOverlay:false,
    slaveToggle:false,
    backgroundImage: DownArrow,
    isClicked: false,
    showCardLimitSlider: false,
    activeAccordian: 0,   
    setLimits:[],
    limitOnline:10,
    totalCreditCurrentLimit: "0",
    totalCreditMaxLimit: "0",
    transactionMode:""

  
  }

  this.handleCardLimitSlider = this.handleCardLimitSlider.bind(this)

}
  componentDidMount(){

   // console.log(this.state.cardData) 
// console.log(this.props.cardData)


    //console.log(this.props.transactionMode)
    if(this.props.transactionMode == "International Transactions"){

      this.setState({
        transactionMode:"INTERNATIONAL"
      })

    }
    if(this.props.transactionMode == "Domestic Transactions"){

      this.setState({
        transactionMode:"DOMESTIC"
      })

    }

    let arr=[];
    let limits = [];
    this.props.cardData.forEach((data,index)=>{

      data.toggle_status === true?arr.push("Y"):arr.push("N");
      limits.push({"limit":data.currentLimit});

     
    });

    this.setState({
      setLimits:limits,
      totalCreditCurrentLimit:this.props.currentCreditLimit,
      totalCreditMaxLimit:this.props.totalCreditLimit
      // this.props.cardData[0].maxLimit
    })

  //  console.log(limits,this.props.totalCreditLimit)

    //always we need to do destructuring for all the levels in array of objects
    //otherwise it will create issue in some where
    let arr1=[...this.props.cardData].map((data,index)=>{
      return {...data};
    })
    this.setState({masterSwitch:this.props.masterSwitch,cardData:arr1,previousToggle:arr.join("")});
  
  }

  handleAccordionClickState = (cardId) => {

    if(cardId == this.state.activeAccordian){

    this.setState({
      activeAccordian:0
    })
  }else{

    this.setState({
      activeAccordian:cardId
    })

  }
   
  };

  handleResetSettings(){

    let masterData=[...this.state.cardData].map((data)=>{
      return {...data,toggle_status:true};
    });

    this.setState({masterSwitch:true,showButton:true,cardData:masterData});


    

    let newLimits = []
    newLimits =[...this.state.setLimits]

    this.state.cardData.forEach((element,index) => {

      if(element.title == "POS"){

        newLimits[index].limit = element.currentLimit;

      }else{

        if(element.currentLimit == 0){

          newLimits[index].limit = '0';

        }else{

        newLimits[index].limit = element.maxLimit;

        }


      }
      
     
      
    });

   // console.log(newLimits)

   let newTotalLimit = '0';

   if(this.props.currentCreditLimit == 0){

    newTotalLimit = '0'

    //this.setState({totalCreditCurrentLimit:this.props.currentCreditLimit})
   }else{

    newTotalLimit = this.props.totalCreditLimit

    //this.setState({totalCreditCurrentLimit:this.props.totalCreditLimit})
   }



   console.log(this.props)

   this.setState({setLimits:newLimits,totalCreditCurrentLimit:newTotalLimit})
  

  }

  handleTotalCreditSlider(event){

    this.setState({
      totalCreditCurrentLimit: event.target.value,
      showButton:true
    })

    //console.log(this.state.totalCreditCurrentLimit)
  }
      
  handleCardLimitSlider(event,cardId,currentLimit){

    let items = [...this.state.setLimits];
    let item = {...items[cardId-1]};
    item.limit = event.target.value;
    items[cardId-1] = item;

    this.setState({setLimits:items});    

    // console.log(this.state.setLimits[1].limit)
    // console.log(this.state.cardData[1].currentLimit)



    if(currentLimit != event.target.value){

      this.setState({
        showButton:true

      })
    }
   
  }

  handleToggle = (index)=>{
    let data=[...this.state.cardData].map((val)=>{
      return {...val};
    });
    data[index-1].toggle_status = !data[index-1].toggle_status;
    let arr=[];
    data.forEach((value,index)=>{
      value.toggle_status === true?arr.push("Y"):arr.push("N");
    });
    let str=arr.join("");

    let mainSwitch =false;
    if(str === "NNNN"){
      mainSwitch=false;
    }else if(str === "YYYY" || arr.includes("Y")){
      mainSwitch=true;
    }

    let saveButtonShow=true;
    if(this.state.previousToggle === str){
      saveButtonShow=false;
    }
    this.setState({cardData:data,showButton:saveButtonShow,slaveToggle:true, masterSwitch:mainSwitch});
  }


  handleMasterToggle = () =>{
    let masterData=[...this.state.cardData].map((data)=>{
      return {...data,toggle_status:!this.state.masterSwitch};
    });
   // console.log(this.state.masterSwitch)

    if(this.state.masterSwitch === true){
      this.setState({masterSwitch:!this.state.masterSwitch,showButton:true ,cardData:masterData,showOverlay:false},()=>{
        if(this.state.masterSwitch === this.props.masterSwitch){
          let arr=[...this.props.cardData].map((data,index)=>{
            return {...data};
          })
          this.setState({showOverlay:false,cardData:arr});
        }
      });
      
    }
    else{
      this.setState({masterSwitch:!this.state.masterSwitch,showButton:true,cardData:masterData});
    }
   
  }
  handleExit=(data)=>{
    let sendData= {"userResponse":""};
    let noChange=false;
    if(data === "Yes"){
      sendData.userResponse = "switchOff";
    }else{
      sendData.userResponse = "No";
      noChange=true;
    };
    let inputString = data + "<split>" + JSON.stringify(sendData);
    window["autosubmit"](inputString);
    if(noChange === true){
      this.handleClick();
    }else{
      this.setState({showOverlay:false});
    } 
  }
  handleChanges = ()=>{

    document.querySelector(".manage-credit-card-sf").style.pointerEvents = "none";
    document.querySelector(".manage-credit-card-sf").style.opacity = "0.8";

    let sendData = null;
    // if(this.state.masterSwitch === true){
    //   sendData= {"userResponse":"switchOn"};
    // }else if(this.state.masterSwitch === false){
    //   sendData={"userResponse":"switchOff"}
    // }
  //  if(this.state.slaveToggle === true){
      let arr=[];
      this.state.cardData.forEach((data,index)=>{
        data.toggle_status === true?arr.push("Y"):arr.push("N");
      });
      // let obj={
      //   "ONLINE_ONOFF_FLAG":arr[0],
      //   "POS_ONOFF_FLAG":arr[1],
      //   "CONTACTLESS_ONOFF_FLAG":arr[2],
      //   "CASH_ONOFF_FLAG":arr[3],
      //   "MOTO_ONOFF_FLAG":arr[4]
      // };

      let obj = {
        "TotalCreditLimit": this.state.totalCreditCurrentLimit,
        "ONLINE":{
          toggle_status: arr[0],
          limit:this.state.setLimits[0].limit

        },
        "POS":{

          toggle_status: arr[1],
          limit:this.state.setLimits[1].limit

        },
        "CONTACTLESS":{

          toggle_status: arr[2],
          limit:this.state.setLimits[2].limit

        },
        "CASH":{

          toggle_status: arr[3],
          limit:this.state.setLimits[3].limit

        },
        "MOTO":{

          toggle_status: arr[4],
          limit:this.state.setLimits[4].limit

        }

      }
      sendData= {"userResponse":obj};
   // }
    let inputString = "Proceed" + "<split>" + JSON.stringify(sendData);
    window["autosubmit"](inputString);

    //console.log(sendData)
  }
  handleCancel = ()=>{

    document.querySelector(".manage-credit-card-sf").style.pointerEvents = "none";
    document.querySelector(".manage-credit-card-sf").style.opacity = "0.8";

    let sendData = {"userResponse":"Cancel"};
    let inputString = "Cancel" + "<split>" + JSON.stringify(sendData);
    window["autosubmit"](inputString);
    //console.log(sendData)
    this.handleClick();
  }
  handleClick =()=>{
    let arr=[...this.props.cardData].map((data,index)=>{
      return {...data};
    })
    this.setState({showOverlay:false,cardData:arr,masterSwitch:this.props.masterSwitch})
  }
  render(){


  

  return (
  
    <MainWrapper className="manage-credit-card-sf disable-item">
 
    
        {/* below master toggle is shown*/}
      {/* <MasterToggle>
  <CardTitle style={{padding:"3px 8px 0px 0px"}}>{this.state.masterSwitch?"SWITCH OFF CARD":"SWITCH ON CARD"}</CardTitle>
        <Toggle>
          <MasterInput type="checkbox" checked={this.state.masterSwitch} onChange={this.handleMasterToggle} />
          <Slider style={this.state.masterSwitch?{background:'#1B9F4E'}:{background:'#b94040'}}></Slider>
        </Toggle>
      </MasterToggle> */}

        <CardLimitSlider style={{background:"#fff"}}>



        <div style={{ display:"flex",justifyContent:"space-between", padding:"12px" }}>
          <div style={{fontWeight:'bold',fontSize:'12px'}}>Set Total Credit Limit</div>
        <div style={{color: "#800000",fontWeight:'bold',fontSize:'13px'}}>
        ₹{this.state.totalCreditCurrentLimit.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")}
        

        </div>
          
        </div>

        <div className="cardSliderContainer" style={{margin: "4px 20px"}}>
          <label>
          <input className="cardSlider"
            // id="cardLimitRange" 
            type="range" 
            min={this.state.totalCreditMaxLimit===0?0:1} max= {this.state.totalCreditMaxLimit}
            value={this.state.totalCreditCurrentLimit}
            onChange={(event)=> {this.handleTotalCreditSlider(event);}}
            step={1}/>
          </label>


        </div>

        <div style={{width:'244px', margin:'0px 20px'}}>

        {/* <div style={{display: "inline-block", padding: "5px 0 0 6px",fontSize:'12px'}}>
        ₹1
        </div> */}

        <div style={{display: "inline-block",float:"right", padding: "5px 0 0 0",fontSize:'12px'}}>
        ₹{this.state.totalCreditMaxLimit.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")}
      
        </div>

        <div style={{fontSize:'12px',width:'100%', textAlign:'center', padding:'16px 0px 20px 0px'}}>
          Current limit : ₹{this.props.currentCreditLimit.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")}
        
        </div>
        
        </div>



        </CardLimitSlider>
        <div style={{width:'100%', padding:'8px 0px 10px 0px'}}>You can set the controls for <b>{this.props.transactionMode}</b> for your credit card <b>{this.props.cardNumberLastFour}</b> below:</div>
      <CardContainer>

      
      <MasterToggle style={{borderBottom:"1px solid #d3d3d3"}}>
  <CardTitle style={{padding:"3px 8px 0px 0px"}}>{this.state.masterSwitch?"SWITCH OFF CARD":"SWITCH ON CARD"}</CardTitle>
        <Toggle>
          <MasterInput type="checkbox" checked={this.state.masterSwitch} onChange={this.handleMasterToggle} />
          <Slider style={this.state.masterSwitch?{background:'#1B9F4E'}:{background:'#b94040'}}></Slider>
        </Toggle>
      </MasterToggle>

      
        {this.state.cardData.map((data, index) => {
          return (
            <div key={index} style={{borderBottom: '1px solid rgba(0,0,0,0.05)'}}>
            <CardWrapper key={data.cardId}>
              
              <Title>
                <CardTitle>{data.title}</CardTitle>
                <Tooltip><p style={{margin:'0',width:'15px',padding:'1px 1px',fontSize:'10px'}}>i</p><TooltipText style={{fontSize:"11px"}} >{data.tooltip_text}</TooltipText></Tooltip>
              </Title>

              <div style={{ display:"flex",justifyContent:"end"}}>
          
              <Toggle>
                <SlaveInput type="checkbox" checked={data.toggle_status} onChange={()=>{this.handleToggle(data.cardId)}}/>
                <Slider></Slider>
              </Toggle>

              

              <CardLimitAccordion onClick={() => {
                // data.toggle_status?
                this.handleAccordionClickState(data.cardId)
                // :null
                }}>
                  <div className={`${this.state.activeAccordian == data.cardId 
                  // && data.toggle_status
                  ?'upArrow':'downArrow'}`} 
                  // style={{pointerEvents: `${data.toggle_status?"auto":"none"}`}}
                  />
              </CardLimitAccordion>

              </div>

            </CardWrapper>

            {/* Accordian */}

            <div>
           {this.state.activeAccordian == data.cardId
            // && data.toggle_status
            ?(
              <CardLimitSlider>

                <div style={{ display:"flex",justifyContent:"space-between", padding:"12px" }}>
                  <div style={{fontWeight:'bold',fontSize:'12px'}}>Set Limit</div>
           <div style={{color: "#800000",fontWeight:'bold',fontSize:'13px'}}>
             ₹{this.state.setLimits[data.cardId-1].limit.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")}
         

             </div>
                  
                </div>

                <div className="cardSliderContainer">
                  <label>
                  <input className="cardSlider" style={data.toggle_status?{pointerEvents:'auto'}:{pointerEvents:'none'}}
                    // id="cardLimitRange" 
                    type="range" 
                    min={data.cardId == 4 && data.maxLimit==0?0:this.state.totalCreditCurrentLimit==0?0:1} 
                    max= {
                      // data.cardId == 4?
                      data.maxLimit
                      // : this.state.totalCreditCurrentLimit
                    }
                    value={this.state.setLimits[data.cardId-1].limit==0?1:this.state.setLimits[data.cardId-1].limit}
                    onChange={(event)=> {if(data.toggle_status){this.handleCardLimitSlider(event,data.cardId,data.currentLimit)}else{
                      null
                    }}}
                    step={1}/>
                  </label>


              </div>

            <div style={{width:'244px', margin:'0px 8px'}}>

              {/* <div style={{display: "inline-block", padding: "5px 0 0 6px",fontSize:'12px'}}>
              ₹{data.cardId == 4 && data.maxLimit==0?0:this.state.totalCreditCurrentLimit==0?0:1}
              </div> */}

              <div style={{display: "inline-block",float:"right", padding: "5px 0 0 0",fontSize:'12px'}}>
              ₹{
              // data.cardId==4?
              data.maxLimit.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")
              // :this.state.totalCreditCurrentLimit.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")
              }
              </div>

              <div style={{fontSize:'12px',width:'100%', textAlign:'center', padding:'16px 0px 20px 0px'}}>
                  Current limit : ₹{data.currentLimit.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")}
                 
              </div>
              </div>



              </CardLimitSlider>
              ) : null}




      </div>
            </div>
          );
        })}

        {/* here reset setting  */}

        <div style={{padding:'28px 0px 16px 0px'}}>
          <div  className= "resetStyle" style={{width:'100%', textAlign:'center', color:'#003E8d', fontSize:'13px', fontWeight:'bold', cursor:'pointer' }} onClick={()=>this.handleResetSettings()}>RESET {this.state.transactionMode} SETTINGS</div>
          <div style={{width:'100%', fontSize:'12px', textAlign:'center',margin:'8px 0px'}}>This feature will switch on all the categories and reset the limits.</div>
        </div>
      </CardContainer>

     

       {/* this UI condition made false in handle function, in future may need  */}
      {this.state.showButton?<div className="action-elem"  onClick={this.handleChanges}>Save Changes</div>:null}
      <div className="action-elem"  onClick={this.handleCancel}>Cancel</div>
      {this.state.showOverlay?
      <OverlayBlock className="disable-item">
      <MessageBlock>
      <CloseButton className="close" onClick={this.handleClick}>&times;</CloseButton>
        <Message><b>Do you really want to switch off your Card? </b><br></br>(Any purchases attempted in Switch Off mode will be declined)</Message>
        <ActionButton onClick={()=>{this.handleExit("Yes")}}>Yes, I’m sure</ActionButton>
        <ActionButton onClick={()=>{this.handleExit("No")}}>No, I did this by mistake</ActionButton>
      </MessageBlock>
    </OverlayBlock>:null}
    </MainWrapper>
  );
  }
};

export default ManageCreditCard;


